import React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import styles from "./statusRadioGroup.module.scss";
import { Box } from "@mui/material";
import StatusText from "../statusText/StatusText";
import { getStatusClassName } from "../../utils/commonFuntion";
import { ReactComponent as RadioIcon } from "../../assets/icons/Radio.svg";
import { ReactComponent as RadioUncheck } from "../../assets/icons/RadioUncheck.svg";
import Button from "../buttons/Buttons";
import {
  StatusEnumValue,
  statusList,
  statusList2,
} from "../../config/appConfig";

import _ from "lodash";
import PropTypes from "prop-types";

const StatusRadioGroup = (props) => {
  const {
    defaultStatus,
    handleClosefn,
    list = 1,
    setActionPopover,
    selectedStatus,
    setSelectedStatus,
    hasSaveAndViewBtn = false,
    handleSaveAndViewBtnClick,
  } = props;

  const handleOnChange = (e) => {
    if (list === 1) {
      setSelectedStatus(
        StatusEnumValue[_.get(e, "target.value", defaultStatus)]
      );
    } else {
      setSelectedStatus(
        StatusEnumValue[_.get(e, "target.value", defaultStatus)]
      );

      e.target.value === "Nee"
        ? setActionPopover(true)
        : setActionPopover(false);
    }
  };
  return (
    <Box
      className={styles.statusRadioGroupWrapper}
      data-testid="StatusRadioGroup"
    >
      <FormControl>
        <RadioGroup
          aria-labelledby="status-radio-group"
          defaultValue={defaultStatus}
          name="status-buttons-group"
          className={styles.radioGroup}
          onChange={(e) => {
            handleOnChange(e);
          }}
        >
          {list === 1
            ? statusList.map((status, key) => (
                <FormControlLabel
                  key={status}
                  value={status}
                  control={
                    <Radio
                      icon={<RadioUncheck />}
                      checkedIcon={<RadioIcon />}
                    />
                  }
                  label={
                    <Box>
                      <StatusText
                        title={status}
                        customClass={getStatusClassName(status)}
                        hasIcon={false}
                        data-testid="status"
                        showPopover={false}
                      />
                    </Box>
                  }
                />
              ))
            : statusList2.map((status, key) => (
                <FormControlLabel
                  key={status}
                  value={status}
                  control={
                    <Radio
                      icon={<RadioUncheck />}
                      checkedIcon={<RadioIcon />}
                    />
                  }
                  label={
                    <Box>
                      <StatusText
                        title={status}
                        customClass={getStatusClassName(status)}
                        hasIcon={false}
                        data-testid="status"
                        showPopover={false}
                      />
                    </Box>
                  }
                />
              ))}
        </RadioGroup>
      </FormControl>
      <Button
        title="Save"
        buttonType="muibtn-primary"
        withIcon={true}
        className={styles.saveBtn}
        handleClick={() => handleClosefn(selectedStatus)}
      />
      {hasSaveAndViewBtn ? (
        <Button
          title="Opslaan en aanpassen"
          buttonType="muibtn-primary"
          withIcon={true}
          className={styles.saveBtn}
          handleClick={() => handleSaveAndViewBtnClick(selectedStatus)}
        />
      ) : null}
    </Box>
  );
};
export default StatusRadioGroup;
StatusRadioGroup.propTypes = {
  defaultStatus: PropTypes.any,
  handleClosefn: PropTypes.any,
  list: PropTypes.any,
  setActionPopover: PropTypes.any,
  selectedStatus: PropTypes.any,
  setSelectedStatus: PropTypes.any,
  hasSaveAndViewBtn: PropTypes.any,
  handleSaveAndViewBtnClick: PropTypes.any,
};
